export default ['$scope', function ($scope) {}];
